import { Component, OnInit } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { JsonService } from '../_services/json.service';
import { LoggerService } from '../_services/logger.service';
import { LoadingService } from '../_services/loading.service';
import { PrescriptionImportErrorListItem } from '../_models/prescription-import-error.model';

@Component({
  selector: 'app-erros-importacao',
  templateUrl: './erros-importacao.component.html',
  styleUrls: ['./erros-importacao.component.scss']
})
export class ErrosImportacaoComponent implements OnInit {
  listaItens: PrescriptionImportErrorListItem[] = [];
  currentPage = 1;
  pageSize = 15;
  totalItems = 0;

  listaPaises: any[] = [];
  listaPDVs: any[] = [];
  listaAno: any[] = [];
  listaMes: any[] = [];
  listaProvedor: any[] = [];

  filtro: any = { country: '', year: '', month: '', pdv: '', provider: '', fileName: '' };

  constructor(
    private jsonService: JsonService,
    private logger: LoggerService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.loadFilters();
    this.consultar();
  }

  get totalPages(): number {
    return this.pageSize > 0 ? Math.max(1, Math.ceil(this.totalItems / this.pageSize)) : 1;
  }

  private loadFilters(): void {
    forkJoin({
      paises: this.jsonService.listCountry(),
      pdvs: this.jsonService.getPDVs(),
      anos: this.jsonService.getAno(),
      meses: this.jsonService.getMes(),
      provedores: this.jsonService.getProvedor()
    }).subscribe({
      next: data => {
        this.listaPaises = data.paises;
        this.listaPDVs = data.pdvs;
        this.listaAno = data.anos;
        this.listaMes = data.meses;
        this.listaProvedor = data.provedores;
      },
      error: err => this.logger.error('Erro ao carregar filtros', err)
    });
  }

  private buildFilterParams(): HttpParams {
    let p = new HttpParams()
      .append('PageNumber', this.currentPage)
      .append('PageSize', this.pageSize);
    Object.entries(this.filtro).forEach(([k, v]) => {
      if (v === '' || v === null || v === undefined) return;
      p = p.append(k, String(v));
    });
    return p;
  }

  consultar(): void {
    this.currentPage = 1;
    this.carregarPagina();
  }

  proximaPagina(): void {
    if (this.currentPage >= this.totalPages) return;
    this.currentPage++;
    this.carregarPagina();
  }

  paginaAnterior(): void {
    if (this.currentPage <= 1) return;
    this.currentPage--;
    this.carregarPagina();
  }

  private carregarPagina(): void {
    this.loadingService.show();
    this.jsonService.listPrescriptionImportErrors(this.buildFilterParams()).subscribe({
      next: resp => {
        this.listaItens = resp.items;
        this.totalItems = resp.totalItems;
        this.loadingService.hide();
      },
      error: err => {
        this.logger.error('Erro ao carregar erros de importação', err);
        this.loadingService.hide();
      }
    });
  }

  limparFiltro(): void {
    this.filtro = { country: '', year: '', month: '', pdv: '', provider: '', fileName: '' };
    this.consultar();
  }

  baixarArquivo(item: PrescriptionImportErrorListItem): void {
    this.jsonService.downloadPrescriptionImportBatch(item.id).subscribe({
      next: (blob: Blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = item.fileName || `${item.id}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      },
      error: err => this.logger.error('Erro ao baixar arquivo', err)
    });
  }
}
